import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { useUtility } from "../../contexts/auth/UtilityContext";
import { SessionView } from "../../firestore/Types/BookingSchema";
import { Roles } from "../../firestore/Types/PermissionSchema";
import { get15minuteIntervals, getRowSpan, getRowStart } from "./CalendarHelpers";
import { faBook, faClose, faCheck } from "@fortawesome/free-solid-svg-icons";

export function CalendarSession({ session, showDay=false, onClick }: { session: SessionView, showDay?:boolean, onClick?: (session: SessionView,infoType:string) => void }) {
    const get15minuterIntervals = get15minuteIntervals();
    const { permission } = useAuth();
    //const calendarBaseSetting = { showDate: true, showTopGutter: true } as CalendarBaseSetting;
    const dates = [] as number[];
    const subjectNames = useUtility().subjects;

    const getSubjectName = (subjectID: string) => {
        // Get subject name from subject ID
        for (const subject of subjectNames) {
            if (subject.Id === subjectID) {
                return subject.SubjectName;
            }
        }
        return "";
    }

    function getCurrentWeekDates() {
        const currentDate = new Date();
        const firstDayOfWeek = currentDate.getDate() - currentDate.getDay() + 1; // Assuming week starts on Monday


        for (let i = 0; i < 7; i++) {
            const date = new Date(currentDate.setDate(firstDayOfWeek + i));
            dates.push(date.getDate());
        }

    }
    getCurrentWeekDates();

    const invokeOnClick = () => {
        if (onClick) {
            onClick(session,"session");
        }
    }

    return (
        <div onClick={invokeOnClick} className={"flex " + getRowStart(session.TimeSlotIndex96) + " " + getRowSpan(session.Duration48)}>

            <div className="cal-session grow flex flex-col m-1 p-2">
               
                {(session.TutorCanceled || session.StudentCanceled) && <div className="text-[10px] text-red-500 grow max-h-4 h-4 bg-red-200 text-center w-20 rounded-lg border border-red-500"><FontAwesomeIcon icon={faClose} title="Suspended" /> Not Active</div>}
                {(session.Completed) && <div className="text-[10px] text-green-500 grow max-h-4 h-4 bg-green-200 text-center w-20 rounded-lg border border-green-500"><FontAwesomeIcon icon={faCheck} title="Completed" /> Completed</div>}
                <div className="flex flex-row mt-2">
                    <div className="cal-time grow">{
                        ((showDay) ? session.SessionTimeStamp.toDate().toDateString() : "")
                    } {get15minuterIntervals[session.TimeSlotIndex96]} - Session</div>
                    <div><FontAwesomeIcon icon={faBook} title="Session" /></div>
                </div>
              
                {permission.Role !== Roles.User ? <div className="cal-description mt-1">Student - {session.StudentName}</div> : <></>}
                {permission.Role !== Roles.Tutor ? <div className="cal-description mt-1">Tutor - {session.TutorName}</div> : <></>}
                <div className="cal-description mt-3">{getSubjectName(session.SubjectId)}</div>
            </div>
        </div>
    );
}